import actions from './action.js'

const state = {
};

const getters = {
};

const mutations = {
};


export default {
    namespaced: true,
    actions,
    state,
    getters,
    mutations
}
